import React from 'react';
import SectionLabel from '../ui/SectionLabel';
import Button from '../ui/Button';
import appInfo from '../../constants/appInfo';
import './DownloadSection.css';

const perks = [
  { icon: '✅', text: '100% Free to download' },
  { icon: '🌐', text: 'Works in Hindi, Marathi & English' },
  { icon: '📶', text: 'Works offline too' },
  { icon: '🔒', text: 'Your data is safe & private' },
];

function DownloadSection() {
  return (
    <section className="download" id="download">
      <div className="download__container">

        {/* ── Blob decoration ── */}
        <div className="download__blob" aria-hidden="true" />

        <div className="download__content">
          <SectionLabel text="📲 Get Dhenika Free" />

          <h2 className="download__heading">
            Start managing your farm{' '}
            <span className="download__heading--accent">today.</span>
          </h2>

          <p className="download__subtext">
            Track your cows and buffaloes with ease using Dhenika. Free
            forever, no hidden charges.
          </p>

          {/* ── Perks ── */}
          <ul className="download__perks">
            {perks.map((p, i) => (
              <li key={i} className="download__perk">
                <span className="download__perk-icon">{p.icon}</span>
                <span className="download__perk-text">{p.text}</span>
              </li>
            ))}
          </ul>

          {/* ── Buttons ── */}
          <div className="download__btns">
            <Button
              variant="primary"
              size="lg"
              href={appInfo.playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              🤖 Download on Google Play
            </Button>
          </div>

          <p className="download__note">
            Available for Android · iOS coming soon
          </p>
        </div>

        {/* ── Right visual ── */}
        <div className="download__visual" aria-hidden="true">
          <div className="download__emoji-stack">
            <span>🐄</span>
            <span>🐃</span>
          </div>
        </div>

      </div>
    </section>
  );
}

export default DownloadSection;